import { render, staticRenderFns } from "./EmptyStateDecks.vue?vue&type=template&id=7f27f8a2&scoped=true"
import script from "./EmptyStateDecks.vue?vue&type=script&lang=js"
export * from "./EmptyStateDecks.vue?vue&type=script&lang=js"
import style0 from "./EmptyStateDecks.vue?vue&type=style&index=0&id=7f27f8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27f8a2",
  null
  
)

export default component.exports